import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type HomepageRankingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HomepageRankingQuery = {
  __typename?: 'Query';
  homepageRanking?: {
    __typename?: 'Random';
    event?: {
      __typename?: 'Event';
      id: string;
      slug?: string | null;
      title?: string | null;
      shortAddress?: string | null;
      contentType?: string | null;
      totalCherries?: number | null;
      sharrySelection?: Types.SharrySelection | null;
      coverPicture?: {
        __typename?: 'GalleryImage';
        id?: string | null;
        bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      } | null;
      sharryKind?: {
        __typename?: 'SharryKind';
        id: string;
        name?: string | null;
        nameIt?: string | null;
        nameEn?: string | null;
        contentType?: Types.SharryContentType | null;
      } | null;
    } | null;
    sharry?: {
      __typename?: 'Sharry';
      id: string;
      slug?: string | null;
      title?: string | null;
      shortAddress?: string | null;
      contentType?: string | null;
      totalCherries?: number | null;
      sharrySelection?: Types.SharrySelection | null;
      coverPicture?: {
        __typename?: 'GalleryImage';
        id?: string | null;
        bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      } | null;
      sharryKind?: {
        __typename?: 'SharryKind';
        id: string;
        name?: string | null;
        nameIt?: string | null;
        nameEn?: string | null;
        contentType?: Types.SharryContentType | null;
      } | null;
    } | null;
    wonder?: {
      __typename?: 'Wonder';
      id: string;
      slug?: string | null;
      title?: string | null;
      shortAddress?: string | null;
      contentType?: string | null;
      totalCherries?: number | null;
      sharrySelection?: Types.SharrySelection | null;
      coverPicture?: {
        __typename?: 'GalleryImage';
        id?: string | null;
        bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      } | null;
      sharryKind?: {
        __typename?: 'SharryKind';
        id: string;
        name?: string | null;
        nameIt?: string | null;
        nameEn?: string | null;
        contentType?: Types.SharryContentType | null;
      } | null;
    } | null;
    sharrylander?: {
      __typename?: 'User';
      id: string;
      slug?: string | null;
      businessName?: string | null;
      name?: string | null;
      surname?: string | null;
      workAddress?: string | null;
      totalCherries?: number | null;
      image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    } | null;
  } | null;
};

export type HomepageCategoriesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HomepageCategoriesQuery = {
  __typename?: 'Query';
  allCategories?: Array<{
    __typename?: 'Category';
    id?: string | null;
    name?: string | null;
    normalizedName?: string | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
};

export type LatestPublicContentsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type LatestPublicContentsQuery = {
  __typename?: 'Query';
  latestPublicContents?: Array<
    | {
        __typename?: 'Event';
        id: string;
        nextUpcomingInstanceDate?: any | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        nextEventInstance?: {
          __typename?: 'EventInstance';
          id: string;
          beginsAt?: any | null;
          endsAt?: any | null;
          hasDates?: boolean | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        soldBySharryland: boolean;
        description?: string | null;
        freeSharryKind?: Types.FreeSharryKind | null;
        requiresPayment?: boolean | null;
        isOnline?: boolean | null;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        variantDuration?: {
          __typename?: 'VariantDuration';
          id: string;
          duration?: number | null;
          durationType?: Types.VariantDurationEnum | null;
        } | null;
        nextUpcomingVariant?: {
          __typename?: 'SharryVariant';
          id: string;
          price?: number | null;
          availability?: number | null;
          unlimitedAvailability?: boolean | null;
          custom?: boolean | null;
          default: boolean;
          discountedPrice?: number | null;
          definitions: Array<{
            __typename?: 'SharryVariantDefinition';
            id: string;
            definitionType?: string | null;
            definitionValue?: string | null;
            beginsAt?: any | null;
            endsAt?: any | null;
          }>;
          discount?: {
            __typename?: 'SharryDiscount';
            id: string;
            kind?: Types.SharryDiscountKind | null;
            percentage?: number | null;
            value?: number | null;
          } | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        distance?: number | null;
        contentType?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        shortAddress?: string | null;
        status: Types.SharryContentStatus;
        slug?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        province?: string | null;
        municipality?: string | null;
        title?: string | null;
        subtitle?: string | null;
        bookmarked?: boolean | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        owner?: {
          __typename?: 'User';
          id: string;
          slug?: string | null;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          stripePayoutsEnabled?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          isSmallOrganisation?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
  > | null;
};

export type HashtagsRankingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HashtagsRankingQuery = {
  __typename?: 'Query';
  hashtagSearch?: Array<{ __typename?: 'Hashtag'; id: string; name: string }> | null;
};

export const HomepageRankingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'homepageRanking' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homepageRanking' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'event' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '160x160', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrySelection' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '160x160', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrySelection' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wonder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '160x160', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrySelection' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharrylander' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workAddress' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class HomepageRankingGQL extends Apollo.Query<HomepageRankingQuery, HomepageRankingQueryVariables> {
  document = HomepageRankingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const HomepageCategoriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'homepageCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequencySort' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '160x160', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class HomepageCategoriesGQL extends Apollo.Query<HomepageCategoriesQuery, HomepageCategoriesQueryVariables> {
  document = HomepageCategoriesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const LatestPublicContentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestPublicContents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestPublicContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CardContent' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardContent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distance' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'province' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipality' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subtitle' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stripePayoutsEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Sharry' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'soldBySharryland' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeSharryKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresPayment' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'variantDuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duration' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'durationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingVariant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SharryVariant' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextUpcomingInstanceDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'freeSharryKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiresPayment' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nextEventInstance' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'beginsAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasDates' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'bookmarked' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharryVariant' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharryVariant' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'availability' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unlimitedAvailability' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'default' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'definitionType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'definitionValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beginsAt' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endsAt' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'discount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kind' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'discountedPrice' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class LatestPublicContentsGQL extends Apollo.Query<
  LatestPublicContentsQuery,
  LatestPublicContentsQueryVariables
> {
  document = LatestPublicContentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const HashtagsRankingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'hashtagsRanking' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hashtagSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagsRanking' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class HashtagsRankingGQL extends Apollo.Query<HashtagsRankingQuery, HashtagsRankingQueryVariables> {
  document = HashtagsRankingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
